import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputDefault from '../../../../components/InputDefault/index.js';
import SelectDefault from '../../../../components/SelectDefault/index.js';
import LoadingCard from './LoadingCard';
import { CardContainer, CardHeader, CardBody, FormGroup } from './CardStyles';
import api from '../../../../services/api.js';

const AddressCard = ({ idDm001, onDataUpdate }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [addressData, setAddressData] = useState({
    idDm002Address: 0,
    tpEnderecoAddress: '',
    nmEnderecoAddress: '',
    dsLogradouroAddress: '',
    nrPredioAddress: '',
    nmBairroAddress: '',
    dsComplementoAddress: '',
    nmCidadeAddress: '',
    nrCepAddress: 0,
    dsReferenciaAddress: '',
    inPadraoAddress: '',
    nmContatoAddress: '',
    inSituacaoAddress: '',
    nmUfAddress: ''
  });

  useEffect(() => {
    const fetchAddressData = async () => {
      if (!idDm001) return;
      
      try {
        setIsLoading(true);
        const addressResponse = await api.get(`address?ID_DM001=${idDm001}`);
        const data = addressResponse.data.data[0];
        
        if (addressResponse.status === 200) {
          const updatedData = {
            idDm002Address: data.ID_DM002,
            tpEnderecoAddress: data.TP_ENDERECO,
            nmEnderecoAddress: data.NM_ENDERECO,
            dsLogradouroAddress: data.DS_LOGRADOURO,
            nrPredioAddress: data.NR_PREDIO,
            nmBairroAddress: data.NM_BAIRRO,
            dsComplementoAddress: data.DS_COMPLEMENTO,
            nmCidadeAddress: data.NM_CIDADE,
            nrCepAddress: data.NR_CEP,
            dsReferenciaAddress: data.DS_REFERENCIA,
            inPadraoAddress: data.IN_PADRAO,
            nmContatoAddress: data.NM_CONTATO,
            inSituacaoAddress: data.IN_SITUACAO,
            nmUfAddress: data.NM_UF
          };
          
          setAddressData(updatedData);
          onDataUpdate(updatedData);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error('Erro ao buscar dados do endereço:', error);
      }
    };

    fetchAddressData();
  }, [idDm001, onDataUpdate]);

  const handleChange = (field, value) => {
    const updatedData = { ...addressData, [field]: value };
    setAddressData(updatedData);
    onDataUpdate(updatedData);
  };

  if (isLoading) {
    return <LoadingCard title="Carregando Dados do Endereço..." />;
  }

  return (
    <CardContainer>
      <CardHeader>
        <h5>Endereço ({addressData.idDm002Address})</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.nmEnderecoAddress}
              onChange={(e) => handleChange('nmEnderecoAddress', e.target.value)}
              Text={'Nome do Endereço'}
            />
          </Col>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.dsLogradouroAddress}
              onChange={(e) => handleChange('dsLogradouroAddress', e.target.value)}
              Text={'Logradouro'}
            />
          </Col>
          <Col xs={12} md={1}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.nrPredioAddress}
              onChange={(e) => handleChange('nrPredioAddress', e.target.value)}
              Text={'Número'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.nmBairroAddress}
              onChange={(e) => handleChange('nmBairroAddress', e.target.value)}
              Text={'Bairro'}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.nrCepAddress}
              onChange={(e) => handleChange('nrCepAddress', e.target.value)}
              Text={'CEP'}
              type={'number'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.nmCidadeAddress}
              onChange={(e) => handleChange('nmCidadeAddress', e.target.value)}
              Text={'Cidade'}
            />
          </Col>
          <Col xs={12} md={3}>
            <SelectDefault
              Width={'100%'}
              Margin={'15px 0px 15px 0px'}
              Text={' UF'}
              value={addressData.nmUfAddress}
              onChange={(e) => handleChange('nmUfAddress', e.target.value)}>
              <option value="ACRE">ACRE</option>
              <option value="ALAGOAS">ALAGOAS</option>
              <option value="AMAPÁ">AMAPÁ</option>
              <option value="AMAZONAS">AMAZONAS</option>
              <option value="BAHIA">BAHIA</option>
              <option value="CEARÁ">CEARÁ</option>
              <option value="DISTRITO FEDERAL">DISTRITO FEDERAL</option>
              <option value="ESPÍRITO SANTO">ESPÍRITO SANTO</option>
              <option value="GOIÁS">GOIÁS</option>
              <option value="MARANHÃO">MARANHÃO</option>
              <option value="MATO GROSSO">MATO GROSSO</option>
              <option value="MATO GROSSO DO SUL">MATO GROSSO DO SUL</option>
              <option value="MINAS GERAIS">MINAS GERAIS</option>
              <option value="PARÁ">PARÁ</option>
              <option value="PARAÍBA">PARAÍBA</option>
              <option value="PARANÁ">PARANÁ</option>
              <option value="PERNAMBUCO">PERNAMBUCO</option>
              <option value="PIAUÍ">PIAUÍ</option>
              <option value="RIO DE JANEIRO">RIO DE JANEIRO</option>
              <option value="RIO GRANDE DO NORTE">RIO GRANDE DO NORTE</option>
              <option value="RIO GRANDE DO SUL">RIO GRANDE DO SUL</option>
              <option value="RONDÔNIA">RONDÔNIA</option>
              <option value="RORAIMA">RORAIMA</option>
              <option value="SANTA CATARINA">SANTA CATARINA</option>
              <option value="SÃO PAULO">SÃO PAULO</option>
              <option value="SERGIPE">SERGIPE</option>
              <option value="TOCANTINS">TOCANTINS</option>
            </SelectDefault>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={3}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.dsComplementoAddress}
              onChange={(e) => handleChange('dsComplementoAddress', e.target.value)}
              Text={'Complemento'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.dsReferenciaAddress}
              onChange={(e) => handleChange('dsReferenciaAddress', e.target.value)}
              Text={'Referência'}
            />
          </Col>
          <Col xs={12} md={2}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={addressData.nmContatoAddress}
              onChange={(e) => handleChange('nmContatoAddress', e.target.value)}
              Text={'Contato'}
            />
          </Col>
          <Col xs={2}>
            <SelectDefault
              Width={'100%'}
              Margin={'15px 0px 15px 0px'}
              Text={'Padrão'}
              value={`${addressData.inPadraoAddress}`}
              onChange={(e) => handleChange('inPadraoAddress', e.target.value)}>
              <option value="S">SIM</option>
              <option value="N">NÃO</option>
            </SelectDefault>
          </Col>
        </Row>
        <Row>
          <Col xs={2}>
            <SelectDefault
              Width={'100%'}
              Margin={'15px 0px 15px 0px'}
              Text={'Situação'}
              value={`${addressData.inSituacaoAddress}`}
              onChange={(e) => handleChange('inSituacaoAddress', e.target.value)}>
              <option value="A">ATIVO</option>
              <option value="I">INATIVO</option>
            </SelectDefault>
          </Col>
        </Row>
      </CardBody>
    </CardContainer>
  );
};

export default AddressCard;
